export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
		},
		{
			text: 'Tipo de Propiedad',
			key: 'article_property_type_id',
			type: 'select',
		},
	],
	singular_model_name_spanish: 'Valor de Propiedad de Articulo',
	plural_model_name_spanish: 'Valores de Propiedad de Articulo',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}